import React from 'react';
import { usePageHeaderTitle } from '../contexts/PageHeaderContext';
import { HubPage } from './ui/HubShell';

interface PageLayoutProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  eyebrow?: string;
  children: React.ReactNode;
}

/**
 * Shared page layout — thin wrapper over HubPage.
 * When the app bar already shows this page's title, the in-page title is hidden.
 */
const PageLayout: React.FC<PageLayoutProps> = ({ title, subtitle, icon, action, eyebrow, children }) => {
  const titleInAppBar = usePageHeaderTitle();
  const hideTitle = titleInAppBar === title;

  return (
    <HubPage
      title={title}
      subtitle={subtitle}
      icon={icon}
      action={action}
      eyebrow={eyebrow}
      hideTitle={hideTitle}
    >
      {children}
    </HubPage>
  );
};

export default PageLayout;
